//#region Modal
var modal = {
    getFirstHighestUsableZIndex() {
        return 1040 + (10 * $('.modal:visible, .kdr-grid-fullscreen-container:visible').length)
    },
    /**
     * Przygotowuje modal do wyswietlenia go na stronie, ogarnia backdrop itd.
     * @param {any} id Identyfikator modala
     * @param {any} options Dodatkowe opcje bootstrapowe
     * @param {any} removeP Mowi czy po zamknieciu modala, modal ma byc usuniety ze strony
     * @param {any} modalForAttribute Okresla dla jakiego elementu jest odpalony modal w attrybucie 'for'
     */
    prepareModal(id, options, removeP = true, modalForAttribute = undefined) {
        if (id == undefined || id == '' || id == null || id.length == 0) {
            throw 'core => modal.prepareModal - Id cannot be empty or undefined etc.'
            return
        }

        let $newModal = $('#' + id)

        if ($newModal.is(':visible')) {
            return
        } else {
            let $modals = $('.modal:visible');
            $('.modal-backdrop').css('opacity', 0.1);
            var zIndex = modal.getFirstHighestUsableZIndex()

            $newModal.modal(options);
            let $modalBackdrop = $('.modal-backdrop').not('.modal-stack')

            let $previousModal = $modals.last()
            let h = $modals.length > 0 ? $previousModal.find('.modal-header').css('height') : 0
            let pt = $modals.length > 0 ? $previousModal.find('.modal-dialog').css('padding-top') : 0

            $modalBackdrop.css('z-index', zIndex - 1)
                .attr('id', id + 'back')
                .addClass('modal-stack')
                .insertBefore($newModal)

            $newModal
                .on('hidden.bs.modal', function () {
                    if (removeP) {
                        $newModal.remove()
                    }
                })
                .on('shown.bs.modal', () => $(document).off('focusin.modal'))
                .css('z-index', zIndex)
                .find('.modal-dialog').css('padding-top', `calc((${h} + ${pt})/2)`)
                .find('.modal-content').addClass('draggable')
                .find('.modal-header').addClass('draggable-handle');
        }

        //$newModal.find('.kdr-grid').on(gridEvents.AFTER_UI_INIT, () => {
        //    $newModal.find('.kdr-grid-input[class*="ds"]').trigger('disabler')
        //})

        $newModal.find(tooltipOtions.selector).tooltip({
            delay: {
                show: tooltipOtions.delay.show,
                hide: tooltipOtions.delay.hide
            },
            boundary: tooltipOtions.boundary,
            trigger: tooltipOtions.trigger
        })

        if (modalForAttribute != undefined) {
            $newModal.attr('for', modalForAttribute)
        }
            
        return $newModal
    },
    ajaxModalType: {
        default: 0,
        info: 1,
        warning: 2,
        danger: 3,
        success: 4,
        showspell: 5
    },
    getModal: {
        default(title = null, message = null, isCloseButton = null, cancelBtnText = null, cancelBtnClasses = null, actionBtnText = null, actionBtnClasses = null, actionBtnCallback = null, $loadingTarget = null, onModalCloseCallback = null, cancelBtnCallback = null, onModalShowCallback = null) {
            modal.getModalAjax({
                type: modal.ajaxModalType.default,
                title: title,
                message: message,
                isCloseButton: isCloseButton,
                cancelBtnText: cancelBtnText,
                cancelBtnClasses: cancelBtnClasses,
                cancelBtnCallback: cancelBtnCallback,
                actionBtnText: actionBtnText,
                actionBtnClasses: actionBtnClasses,
                actionBtnCallback: actionBtnCallback,
                $loadingTarget: $loadingTarget,
                onModalShowCallback: onModalShowCallback,
                onModalCloseCallback: onModalCloseCallback
            })
        },
        info(title = null, message = null, isCloseButton = null, cancelBtnText = null, cancelBtnClasses = null, actionBtnText = null, actionBtnClasses = null, actionBtnCallback = null, $loadingTarget = null, onModalCloseCallback = null, cancelBtnCallback = null, onModalShowCallback = null) {
            modal.getModalAjax({
                type: modal.ajaxModalType.info,
                title: title,
                message: message,
                isCloseButton: isCloseButton,
                cancelBtnText: cancelBtnText,
                cancelBtnClasses: cancelBtnClasses,
                cancelBtnCallback: cancelBtnCallback,
                actionBtnText: actionBtnText,
                actionBtnClasses: actionBtnClasses,
                actionBtnCallback: actionBtnCallback,
                $loadingTarget: $loadingTarget,
                onModalShowCallback: onModalShowCallback,
                onModalCloseCallback: onModalCloseCallback
            })
        },
        warning(title = null, message = null, isCloseButton = null, cancelBtnText = null, cancelBtnClasses = null, actionBtnText = null, actionBtnClasses = null, actionBtnCallback = null, $loadingTarget = null, onModalCloseCallback = null, cancelBtnCallback = null, onModalShowCallback = null) {
            modal.getModalAjax({
                type: modal.ajaxModalType.warning,
                title: title,
                message: message,
                isCloseButton: isCloseButton,
                cancelBtnText: cancelBtnText,
                cancelBtnClasses: cancelBtnClasses,
                cancelBtnCallback: cancelBtnCallback,
                actionBtnText: actionBtnText,
                actionBtnClasses: actionBtnClasses,
                actionBtnCallback: actionBtnCallback,
                $loadingTarget: $loadingTarget,
                onModalShowCallback: onModalShowCallback,
                onModalCloseCallback: onModalCloseCallback
            })
        },
        danger(title = null, message = null, isCloseButton = null, cancelBtnText = null, cancelBtnClasses = null, actionBtnText = null, actionBtnClasses = null, actionBtnCallback = null, $loadingTarget = null, onModalCloseCallback = null, cancelBtnCallback = null, onModalShowCallback = null) {
            modal.getModalAjax({
                type: modal.ajaxModalType.danger,
                title: title,
                message: message,
                isCloseButton: isCloseButton,
                cancelBtnText: cancelBtnText,
                cancelBtnClasses: cancelBtnClasses,
                cancelBtnCallback: cancelBtnCallback,
                actionBtnText: actionBtnText,
                actionBtnClasses: actionBtnClasses,
                actionBtnCallback: actionBtnCallback,
                $loadingTarget: $loadingTarget,
                onModalShowCallback: onModalShowCallback,
                onModalCloseCallback: onModalCloseCallback
            })
        },
        success(title = null, message = null, isCloseButton = null, cancelBtnText = null, cancelBtnClasses = null, actionBtnText = null, actionBtnClasses = null, actionBtnCallback = null, $loadingTarget = null, onModalCloseCallback = null, cancelBtnCallback = null, onModalShowCallback = null) {
            modal.getModalAjax({
                type: modal.ajaxModalType.success,
                title: title,
                message: message,
                isCloseButton: isCloseButton,
                cancelBtnText: cancelBtnText,
                cancelBtnClasses: cancelBtnClasses,
                cancelBtnCallback: cancelBtnCallback,
                actionBtnText: actionBtnText,
                actionBtnClasses: actionBtnClasses,
                actionBtnCallback: actionBtnCallback,
                $loadingTarget: $loadingTarget,
                onModalShowCallback: onModalShowCallback,
                onModalCloseCallback: onModalCloseCallback
            })
        },
        showspell(title = null, message = null, isCloseButton = null, cancelBtnText = null, cancelBtnClasses = null, actionBtnText = null, actionBtnClasses = null, actionBtnCallback = null, $loadingTarget = null, onModalCloseCallback = null, cancelBtnCallback = null, onModalShowCallback = null) {
            modal.getModalAjax({
                type: modal.ajaxModalType.showspell,
                title: title,
                message: message,
                isCloseButton: isCloseButton,
                cancelBtnText: cancelBtnText,
                cancelBtnClasses: cancelBtnClasses,
                cancelBtnCallback: cancelBtnCallback,
                actionBtnText: actionBtnText,
                actionBtnClasses: actionBtnClasses,
                actionBtnCallback: actionBtnCallback,
                $loadingTarget: $loadingTarget,
                onModalShowCallback: onModalShowCallback,
                onModalCloseCallback: onModalCloseCallback
            })
        }
    },
    /**
     * Create modal on server side and return to current view and display it.
     * Text must be in L.t format.
     * @param type  Modal type, default: 0.
     * @param title  Modal title.
     * @param message Message for user.
     * @param isCloseButton Tell if server should render close button on right top side.
     * @param cancelBtnText Text for the white button which is closing modal. Default is "OK".
     * @param cancelBtnClasses Additional classes for white button.
     * @param actionBtnText Text for blue button, if it`s null then it wont be rednered.
     * @param actionBtnClasses Additonal classes for the blue button.
     * @param actionBtnCallback Additional callback pinned 'onClick' on blue button. Callback returns modal.
     * @param $loadingTarget Items to show loading on them.
     */
    getModalAjax(options = { type: null, title: null, message: null, isCloseButton: null, cancelBtnText: null, cancelBtnClasses: null, actionBtnText: null, actionBtnClasses: null, actionBtnCallback: null, $loadingTarget: null, onModalCloseCallback: null, cancelBtnCallback: null, onModalShowCallback: null }) {
        $.ajax({
            type: "POST",
            url: __root + "Modal/GetAjaxModal",
            traditional: true,
            datatype: "html",
            data: {
                Type: options.type,
                Title: options.title,
                Message: options.message,
                IsCloseButton: options.isCloseButton,
                actionBtnText: options.actionBtnText,
                actionBtnClasses: options.actionBtnClasses,
                cancelBtnText: options.cancelBtnText,
                cancelBtnClasses: options.cancelBtnClasses
            },
            success: function (response) {
                let $modal = $($.parseHTML(response)[1])
                $('body').append($modal)

                options.onModalShowCallback && $modal.on('show.bs.modal', options.onModalShowCallback($modal))
                options.onModalCloseCallback && $modal.on('hidden.bs.modal', options.onModalCloseCallback($modal))

                if ($modal.hasClass('modal')) {
                    let mId = $modal.attr('id')
                    modal.prepareModal(mId, { keyboard: false, backdrop: 'static' });

                    if (options.actionBtnText != null && options.actionBtnCallback) {
                        $modal.find('.modal-ajax-btn_action').on('click', function () {
                            options.actionBtnCallback && options.actionBtnCallback($modal)
                        })
                    }
                    options.cancelBtnCallback && $modal.find('.modal-ajax-btn_cancel').on('click', function () {
                        options.cancelBtnCallback($modal)
                    })
                }
            },
            beforeSend: function () {
                loading.show(options.$loadingTarget)
            },
            complete: function () {
                loading.hide(options.$loadingTarget)
                loading.hide($('.kdr-grid-on-failed-hide-loading'))
            }
        })
    },
    hideClosest(button) {
        $(button).closest('.modal').modal('toggle')
    }
}

var modalHelper = {
    addModalToBody(html, $loadingIndicator) {
        $('.modal.disposable-modal:not(.show)').remove()
        $loadingIndicator && loading.show($loadingIndicator)
        let $modal

        try {
            $modal = convert.toJqueryObject(html)
            let id = $modal.attr('id');
            $modal.addClass('disposable-modal');
            $('body').append($modal);
            modal.prepareModal(id, { keyboard: false, backdrop: 'static' });

            //let $subtitle = $modal.find('.modal-subtitle-text');
            let $titleContainer = $modal.find('.modal-title');

            if ($titleContainer[0].scrollWidth > $titleContainer[0].offsetWidth) {
                $titleContainer.attr('data-original-title', $titleContainer[0].innerHTML);
            }

            tooltipHelper.init($modal, { html: true })
            pickers.init($modal);

        } catch (exception) {
            console.error("modalHelper.addModalToBody")
            console.error(exception)
            toastr.error("Something went wrong, try again later.", "Ups...")
        }
        $loadingIndicator && loading.hide($loadingIndicator)

        return $modal;
    },
    getModal(endpoint, data, $loadingTarget, successCallback) {

        if ($loadingTarget != undefined && $loadingTarget != null) {
            $loadingTarget = convert.toJqueryObject($loadingTarget)

            if ($loadingTarget.isAny() && $loadingTarget.hasClass('kdr-new-grid-dot-button')) {
                let buttonId = $loadingTarget.closest('.dropdown-menu').attr('aria-labelledby')
                $loadingTarget = $(`#${buttonId}`)
            }
        }


        $.ajax({
            type: "POST",
            url: window.location.origin + __root + endpoint,
            datatype: "json",
            traditional: true,
            data: data,
            success: function (response) {
                let $response = $(response)

                if (response.code == gridResponseCodes.WARNING) {
                    modal.getModal.warning("~{Attention}", response.message, true)
                } else if (response.code == gridResponseCodes.INFO) {
                    modal.getModal.info("~{Info}", response.message, true)
                } else if (response.code == gridResponseCodes.ERROR) {
                    modal.getModal.danger(__l.Error, response.message, true)
                } else if ($response.find('#page-error').isAny()) {
                    let msg = $response.find('.error-text-desc').text()?.trim() ?? ''
                    modal.getModal.danger(__l.Error, msg, true)
                } else {

                    let $modal
                    if (!(undefined == response || null == response || response == '')) {
                        $modal = modalHelper.addModalToBody($response)
                    }

                    successCallback && successCallback($modal)
                }
            },
            error: function (response) {
                modal.getModal.danger(response.status, response.statusText, true)
            },
            beforeSend: function () {
                loading.show($loadingTarget)
            },
            complete: function () {
                loading.hide($loadingTarget)
            }
        })
    },
    removeModalFromBody($modal) {
        $modal.modal('hide')
        $modal.remove()
    }
}


$(document).on('mouseover', '.draggable:not(.reset-inset)', function () {
    let $this = $(this)
    let $handle = $this.find('.draggable-handle')
    let key = 'draggableResetInitedP'
    let isInited = $this.data(key)

    if (isInited) return

    $this.draggable({
        handle: $handle,
        scroll: false,
        drag: function () {
            let $this = $(this)
            let $handle = $this.find('.draggable-handle')

            $.each($handle.isInViewport(), function (propertyName, propertyValue) {
                if (propertyValue == false) {
                    $handle.mouseup()
                    if ($handle.closest('.modal').length > 0) {
                        let oldStyles = $this.attr('style').split(';').filter(f => f.length > 0).map(u => u.trim())

                        //"yAxlepx auto auto xAxlepx"
                        let styles = oldStyles.filter(u => u.includes('inset'))
                        let insets = []
                        if (styles.length > 0) {
                            insets = styles[0].split(':')[1].trim().split(' ')
                        }

                        insets[0] = '0px'
                        insets[3] = '0px'

                        let newStyles = oldStyles.filter(u => !u.includes('inset'))
                        newStyles.push('inset: ' + insets.join(' '))

                        $this.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
                            $this.attr('style', newStyles.join("; ").trim())
                                .removeClass('reset-inset')
                        })
                            .addClass('reset-inset')

                        return false
                    } else {
                        $this.css('inset', '')
                    }
                }
            })

        },
        stop: function () {
            $this.css('height', '')
        }
    })

    $handle.css('cursor', 'move')

    $this.data(key, !isInited)
})
$(document).on('click', '.hide-closest-modal', function () {
    modal.hideClosest(this)
})
$(document).on('hidden.bs.modal', '.modal', function () {
    $('.modal:visible').length && $(document.body).addClass('modal-open');
    $('.modal-backdrop').last().css('opacity', 0.5);
});
$(document).on('click', '.warning-on-cancel', function () {
    let $this = $(this)
    let $mainModal = $this.closest('.modal')
    modal.getModal.warning('~{Warning}', '~{Are you sure you want to cancel? Your changes will not be saved.}', true, '~{Close}', null, '~{Confirm}', null, function ($modal) {
        $modal.modal('hide')
        $mainModal.modal('hide')
    }, $this)

})
$(document).on('click', '.modal-confirm-on-close', function () {

    let $this = $(this)
    let $baseModal = $(this).closest('.modal')

    modal.getModal.default('~{Cancellation confirmation}', '~{Are you sure you want to cancel? Your changes will not be saved.}', true, '~{Close}', null, '~{Confirm}', 'kdr-grid-remove-confirm btn-primary', function ($modal) {
        $modal.modal('hide')
        $baseModal.modal('hide')
        $baseModal.remove()
    }, $this, null, null, function ($modal) {
        $modal.addClass('kdr-grid-delete-modal')
    })
})

//#endregion Modal